import { motion, AnimatePresence } from "motion/react";
import { useState, useEffect } from "react";

interface Wave {
  id: number;
  x: number;
  y: number;
}

export function ClickWaveProvider({ children }: { children: React.ReactNode }) {
  const [waves, setWaves] = useState<Wave[]>([]);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const newWave = {
        id: Date.now(),
        x: e.clientX,
        y: e.clientY,
      };
      
      setWaves(prev => [...prev, newWave]);
      
      setTimeout(() => {
        setWaves(prev => prev.filter(w => w.id !== newWave.id));
      }, 1000);
    };

    window.addEventListener("click", handleClick);
    return () => window.removeEventListener("click", handleClick);
  }, []);

  return (
    <>
      {children}
      <div className="fixed inset-0 pointer-events-none z-[999]">
        <AnimatePresence>
          {waves.map(wave => (
            <motion.div
              key={wave.id}
              initial={{
                scale: 0,
                opacity: 0.6,
                x: wave.x - 50,
                y: wave.y - 50,
              }}
              animate={{
                scale: 4,
                opacity: 0,
              }}
              exit={{
                opacity: 0,
              }}
              transition={{
                duration: 0.8,
                ease: "easeOut",
              }}
              className="absolute w-24 h-24 rounded-full border-2 border-amber-400"
            />
          ))}
        </AnimatePresence>
      </div>
    </>
  );
}
